import { useState } from "react";
import "../../home/home.css"
import "./styles.css"

import teste from "../../../assets/general_assets/Logo1.jpg"

export default function CommentaryList({ commentaries }) {

    const [pagina, setPagina] = useState(0)
    const commentsPagina = 3;   

    const totalPaginas = Math.ceil(commentaries.length / commentsPagina)


    const inicio = pagina * commentsPagina;
    const fim = inicio + commentsPagina;
    const visibleComments = commentaries.slice(inicio, fim)


    return (
        <>
            <div className="comentary_cards">

                <button id="prevComment" 
                    onClick={() => setPagina(pagina - 1)} disabled={pagina === 0} class="bi bi-arrow-left-circle">
                </button>


                {visibleComments.map((comment, i) => {

                    return (
                        <div key={i} className="comentary">
                            <span className="comentary_person">
                                <img src={teste} />
                                <p className="comentary_name">{comment.name}</p>
                            </span>
                            <div className="comentary_text">

                                <p>
                                    {comment.text}
                                </p>


                            </div>
                            <p style={{ padding: "10px" }}>{comment.date}</p>

                        </div>
                    )

                })}


                <button id="nextComment" 
                    onClick={() => setPagina(pagina + 1)} disabled={fim >= commentaries.length} class="bi bi-arrow-right-circle">

                    </button>

            </div>
            <div className="dots">
                {Array.from({ length: totalPaginas }).map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${pagina === index ? "ativo" : ""}`}
                        onClick={() => setPagina(index)}
                    ></span>
                ))}
            </div>

        </>
    )

}